module.exports = __webpack_public_path__ + "static/media/All-in-one.dfcde3a7.png";